import { FilterItem } from 'infra/FiltersViewModel'
import { JobProgressionStepFilterOption } from 'jobs/views/JobManagement/JobProgressionFilterOption'
import { JobScopeChangeStatusFilterOption } from 'jobs/views/JobManagement/JobScopeChangeStatusFilterOption'
import { JobStatusFilterOption } from 'jobs/views/JobManagement/JobStatusFilterOption'
import { JobWaitingOnFilterOption } from 'jobs/views/JobManagement/JobWaitingOnFilterOption'
import { JobPeriodFilterOption } from 'jobs/views/JobManagement/JobPeriodFilterOption'

/**
 * Options for the job status filter.
 */
export const StatusOptions = [
  {
    title: 'Unclaimed',
    value: JobStatusFilterOption.Unclaimed,
  },
  {
    title: 'Closed',
    value: JobStatusFilterOption.Closed,
  },
  {
    title: 'Info Gathering',
    value: JobStatusFilterOption.InfoGathering,
  },
  {
    title: 'Idle',
    value: JobStatusFilterOption.Idle,
  },
  {
    title: 'In Progress',
    value: JobStatusFilterOption.InProgress,
  },
  {
    title: 'Onboarding',
    value: JobStatusFilterOption.Onboarding,
  },
  {
    title: 'On Hold',
    value: JobStatusFilterOption.OnHold,
  },
] as FilterItem<JobStatusFilterOption>[]

/**
 * Options for the progression step filter.
 */
export const ProgressionStepOptions = [
  {
    title: 'None',
    value: JobProgressionStepFilterOption.None,
  },
  {
    title: 'Review documents',
    value: JobProgressionStepFilterOption.NotStarted,
  },
  {
    title: 'Open items',
    value: JobProgressionStepFilterOption.OpenItems,
  },
  {
    title: 'Job started',
    value: JobProgressionStepFilterOption.JobStarted,
  },
  {
    title: 'Draft review',
    value: JobProgressionStepFilterOption.DraftInReview,
  },
  {
    title: 'Changes requested',
    value: JobProgressionStepFilterOption.DraftRejected,
  },
  {
    title: 'Draft approved',
    value: JobProgressionStepFilterOption.DraftApproved,
  },
  {
    title: 'Authorization requested',
    value: JobProgressionStepFilterOption.AuthorizationRequested,
  },
  {
    title: 'Authorization received',
    value: JobProgressionStepFilterOption.AuthorizationSigned,
  },
  {
    title: 'Return filed',
    value: JobProgressionStepFilterOption.ReturnFiled,
  },
  {
    title: 'Preparation complete',
    value: JobProgressionStepFilterOption.PreparationCompleted,
  },
  {
    title: 'Review complete',
    value: JobProgressionStepFilterOption.ReviewCompleted,
  },
  {
    title: 'Extension in progress',
    value: JobProgressionStepFilterOption.ExtensionInProgress,
  },
  {
    title: 'Extension confirmed',
    value: JobProgressionStepFilterOption.ExtensionConfirmed,
  },
  {
    title: 'Extension accepted',
    value: JobProgressionStepFilterOption.ExtensionAccepted,
  },
  {
    title: 'Extension rejected',
    value: JobProgressionStepFilterOption.ExtensionRejected,
  },
  {
    title: 'Waiting on client',
    value: JobProgressionStepFilterOption.WaitingOnClient,
  },
  {
    title: 'Ready to file',
    value: JobProgressionStepFilterOption.ReadyToFile,
  },
]

/**
 * Options for the job scope change request status filter.
 */
export const JobScopeUpdatesOptions = [
  {
    title: 'Pending review',
    value: JobScopeChangeStatusFilterOption.PendingReview,
  },
  {
    title: 'Accepted',
    value: JobScopeChangeStatusFilterOption.Accepted,
  },
  {
    title: 'Rejected',
    value: JobScopeChangeStatusFilterOption.Rejected,
  },
]

/**
 * Options for the job waiting on filter.
 */
export const WaitingOnOptions = [
  {
    title: 'Client',
    value: JobWaitingOnFilterOption.Client,
  },
  {
    title: 'Pro',
    value: JobWaitingOnFilterOption.Provider,
  },
] as FilterItem<JobWaitingOnFilterOption>[]

/**
 * Options for the job period filter.
 */
export const JobPeriodOptions = [
  {
    title: 'All jobs',
    value: JobPeriodFilterOption.All,
  },
  {
    title: 'Current jobs',
    value: JobPeriodFilterOption.Current,
  },
  {
    title: 'Old jobs',
    value: JobPeriodFilterOption.Old,
  },
] as FilterItem<JobPeriodFilterOption>[]
